<template>
  <ckeditor
    :editor="editor"
    v-model="editorData"
    :config="editorConfig"
    @ready="onReady"
  />
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
export default {
  name: "BaseRichTextDisplay",
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component
  },
  props: {
    // the actual string for editing
    content: {
      type: String,
      required: true,
      default: "Placeholder"
    }
  },
  data() {
    return {
      editor: DecoupledEditor,
      editorData: this.content,
      editorConfig: {
        toolbar: []
      }
    };
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.isReadOnly = true;
    }
  }
};
</script>
